// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td[data-v-413d895e]{min-width:100px}.no-data-text[data-v-413d895e]{text-align:center;color:rgba(0,0,0,.38);padding-top:6px}", ""]);
// Exports
module.exports = exports;
